import React from 'react';
import { Modal as OmModal, ModalProps as OmModalProps } from '@moda/om';
import { getModalShards } from './getModalShards';

export type ModalProps = OmModalProps;

export const Modal: React.FC<ModalProps> = ({ shards, ...rest }) => (
  <OmModal shards={[...getModalShards(), ...(shards ?? [])]} {...rest} />
);
